import { useOutletContext } from "react-router-dom";
import PaymentFailed from "../../shared/PaymentFailed";

const OplPaymentFailed = () => {
  const { merchant, payment } = useOutletContext();

  return (<PaymentFailed
    merchant={merchant}
    reference={payment.reference}
    retryUrl={`/payto/${merchant.organisationId}`} />);
};

export default OplPaymentFailed;
